import type { FC } from 'react';
import React, { forwardRef } from 'react';
import { generateBoxClassNames } from '@/DesignSystem/Helper';
import type { IBoxProps } from '@/DesignSystem/Model/DataModel';
const Box = forwardRef<ReturnType<FC<IBoxProps>>, IBoxProps>(({
  as,
  href,
  children,
  ...props
}, ref) => {
  const Component = as ?? `div`;
  const componentProps = {
    className: generateBoxClassNames({
      ...props
    })
  };
  return <Component ref={ref} href={href} {...componentProps}>
      {children}
    </Component>;
});
Box.displayName = 'Box';
Box.defaultProps = {
  as: 'div',
  color: 'white'
};
export default Box;